/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Endpoint_Try_RunInputs */

const en_endpoint_try_run = /** @type {(inputs: Endpoint_Try_RunInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Run it`)
};

const zh_hans1_endpoint_try_run = /** @type {(inputs: Endpoint_Try_RunInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`运行`)
};

const pt_br2_endpoint_try_run = /** @type {(inputs: Endpoint_Try_RunInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Executar`)
};

const es_endpoint_try_run = /** @type {(inputs: Endpoint_Try_RunInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ejecutar`)
};

const fr_endpoint_try_run = /** @type {(inputs: Endpoint_Try_RunInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lancer`)
};

const de_endpoint_try_run = /** @type {(inputs: Endpoint_Try_RunInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ausführen`)
};

const ru_endpoint_try_run = /** @type {(inputs: Endpoint_Try_RunInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Запустить`)
};

const it_endpoint_try_run = /** @type {(inputs: Endpoint_Try_RunInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Eseguilo`)
};

/**
* | output |
* | --- |
* | "Run it" |
*
* @param {Endpoint_Try_RunInputs} inputs
* @param {{ locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }} options
* @returns {LocalizedString}
*/
export const endpoint_try_run = /** @type {((inputs?: Endpoint_Try_RunInputs, options?: { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Endpoint_Try_RunInputs, { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh-Hans") return zh_hans1_endpoint_try_run(inputs)
	if (locale === "pt-BR") return pt_br2_endpoint_try_run(inputs)
	if (locale === "es") return es_endpoint_try_run(inputs)
	if (locale === "fr") return fr_endpoint_try_run(inputs)
	if (locale === "de") return de_endpoint_try_run(inputs)
	if (locale === "ru") return ru_endpoint_try_run(inputs)
	if (locale === "it") return it_endpoint_try_run(inputs)
	return en_endpoint_try_run(inputs)
});